import { useState, useEffect } from "react";
import { Helmet } from "react-helmet-async";
import Layout from "../components/Layout";

function Blog() {

  const [posts, setPosts] = useState([]);

  useEffect(() => {
    fetch("/uploads/blog_posts.json")
      .then(response => response.json())
      .then(data => {
        const sorted = data.sort((a, b) => b.id - a.id);
        setPosts(sorted);
      })
      .catch(error => console.error("Error fetching posts:", error));
  }, []);

  if (posts.length === 0) return <p>Loading...</p>;

  return (
    <Layout>
        <Helmet>
        <title>Blog | Croquette</title>
        </Helmet>
        <h1 className="text-3xl font-bold mb-6">Blog</h1>
        {posts.map(post => (
            <div key={post.id} className="mb-8 p-4 border rounded shadow">
            <h2 className="text-2xl font-bold">{post.title}</h2>
            <p className="text-gray-600">{post.date}</p>
            <p className="mt-2">{post.content}</p>
            {post.image && (
                <img
                src={post.image}
                alt="Post GIF"
                className="mt-4 rounded shadow-lg w-full max-w-md"
                />
            )}
            </div>
      ))}
    </Layout>
  );
}

export default Blog;
